export class Constants {

    static EXTENSION_CHROME_WEBSTORE_LINK = "https://chrome.google.com/webstore/category/extensions"
}